<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Breaks Validation Errors</h4>
  <button
    nf-icon-button="secondary"
    icon="close"
    class="btn-bare close"
    ngbTooltip="Close"
    (click)="onDismissModal()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <ul>
    <li *ngFor="let result of validationResults">
      {{ 'BreakId = ' + result.breakId }}: {{ 'Message = ' + result.messages }}
    </li>
  </ul>
</div>
